import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { EventLoyaltyTypeRecord } from '../types/model';
import { getAndDeleteURLParameters } from '../utils/url';

interface UseEventFiltersProps {
  filterEventState: string[];
  updateFilter: (value: EventLoyaltyTypeRecord) => void;
  resetFilter: () => void;
}

export const useEventFilters = (
  filterUrlParam: string
): UseEventFiltersProps => {
  const history = useHistory();
  const [filterEventState, setFilterEventState] = useState<string[]>([
    ...(filterUrlParam ? filterUrlParam.toUpperCase().split(',') : []),
  ]);

  // store filter parameters in url
  useEffect(() => {
    // Only append the `filterEventState` when one of the dropdown filters are selected.
    if (filterEventState.length > 0) {
      history.push('?filter=' + filterEventState.join(',').toLowerCase());
    } else {
      history.replace({
        search: getAndDeleteURLParameters('filter') || '',
      });
    }
  }, [filterEventState, history]);

  const updateFilter = (value: EventLoyaltyTypeRecord): void => {
    if (!value) return;
    if (filterEventState.includes(value.toString())) {
      setFilterEventState(
        filterEventState.filter((x) => value.toString() !== x)
      );
    } else {
      setFilterEventState([
        ...new Set([...filterEventState, value.toString()]),
      ]);
    }
  };

  const resetFilter = (): void => {
    setFilterEventState([]);
  };

  return {
    filterEventState,
    updateFilter,
    resetFilter,
  };
};
